module.exports = __webpack_public_path__ + "img/icon_python.b6db5bb3.png";